export default function FeatureCards() {
  const features = [
    {
      icon: 'ri-search-eye-line',
      title: 'Faster Product Discovery',
      desc: 'Find products through organized categories with instant access to curated spreadsheet directories.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Better Comparison',
      desc: 'Compare products, features, and buying options side by side in structured spreadsheet views.',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Beginner Friendly',
      desc: 'Learn how spreadsheet shopping works step by step with clear guides and visual tutorials.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Updated Information',
      desc: 'Access regularly refreshed resources with new product additions and current pricing data.',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 text-center mb-8">
          Why Use Hipobuy Spreadsheet?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feat) => (
            <div key={feat.title} className="bg-background-50 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-4">
                <i className={`${feat.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}